import * as Sentry from '@sentry/react';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

dayjs.locale('de');

Sentry.init({
  dsn: 'https://a8912b38e12c609faf433f1aa36ba97a@o255832.ingest.us.sentry.io/4509354219339776',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      autoInject: false,
    }),
  ],
  sendDefaultPii: true,
});

if (window.top !== window.self) {
  // In IFRAME

  // Request AUTH_DATA from the parent window
  window.parent.postMessage({ type: 'REQUEST_AUTH_DATA' }, '*');

  window.addEventListener('message', (event) => {
    if (event.data.type === 'AUTH_DATA') {
      const { payload } = event.data;
      // Use the data
      const key = `oidc.user:${import.meta.env.VITE_AUTHORITY}:${import.meta.env.VITE_CLIENT_ID}`;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, JSON.stringify(payload));
        console.log(payload, 'AUTH_DATA received', sessionStorage.getItem(key));
        window.location.reload();
      }
    }
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
